<div class="d-flex flex-column align-items-center gap-medium">
  <img
    src="wealth-assets/icons/golrang-icon.png"
    alt="golrang-bottomsheet"
  />
  <span class="st-7 text-onback-high">تغییر نام صندوق ارزش آفرین گلرنگ</span>
  <div class="text-align-center b-2">
    <span
      >نام این صندوق به
      <span class="st-7">ارزش آفرین گلبرگ</span>
      تغییر یافت. تغییرات فقط مربوط به نام صندوق است و هیچ کدام از ارکان صندوق نظیر مدیر صندوق و غیره تغییر نکرده است.</span
    >
  </div>
  <div class="w-100 mt-big">
    <ngx-button
      class="mt-4"
      [style]="'fill'"
      [fullWidth]="true"
      [mode]="'form'"
      (clickHandler)="close()"
    >
      متوجه شدم
    </ngx-button>
  </div>
</div>
